<template>
  <div>
    <md-dialog-confirm
      :md-active.sync="showDialog"
      :md-title="dialogTitle"
      :md-confirm-text="$t('confirm')"
      :md-cancel-text="$t('cancel')"
      @md-confirm="dialogAction">
    </md-dialog-confirm>
    <md-dialog :md-active.sync="report.dialog" @md-opened="$focusMdDialog()" @md-closed="closeReportDialog" class="dialog-report">
      <md-dialog-title class="md-primary">{{ $t('downloadServiceDeskReport') }}</md-dialog-title>
      <md-dialog-content>

        <md-field :class="{'md-invalid': errors.has('startDate') || daysDiffGreaterThanSevenDays || reportStartDateGreaterThanEnd}">
          <i class="md-icon md-icon-font md-primary">event</i>
          <label for="startDate">{{$t('startDate')}}</label>
          <md-input
            name="startDate"
            type="date"
            v-validate="'required'"
            v-model="report.startDate">
          </md-input>
          <span class="md-error" v-if="daysDiffGreaterThanSevenDays">{{ $t('maxDateRangeDifference') }}</span>
          <span class="md-error" v-else-if="reportStartDateGreaterThanEnd">{{ $t('endDateMustBeGreaterThanStart') }}</span>
          <span class="md-error" v-else>{{ $t('requiredWarning') }}</span>
        </md-field>

        <md-field :class="{'md-invalid': errors.has('endDate') || daysDiffGreaterThanSevenDays || reportStartDateGreaterThanEnd}">
          <i class="md-icon md-icon-font md-primary">event</i>
          <label for="endDate">{{$t('endDate')}}</label>
          <md-input
            name="endDate"
            type="date"
            v-validate="'required'"
            v-model="report.endDate">
          </md-input>
          <span class="md-error" v-if="daysDiffGreaterThanSevenDays">{{ $t('maxDateRangeDifference') }}</span>
          <span class="md-error" v-else-if="reportStartDateGreaterThanEnd">{{ $t('endDateMustBeGreaterThanStart') }}</span>
          <span class="md-error" v-else>{{ $t('requiredWarning') }}</span>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="closeReportDialog">{{ $t('cancel') }}</md-button>
          <md-button class="md-primary" @click="downloadReport">{{ $t('download') }}</md-button>
        </md-dialog-actions>
      </md-dialog-content>
    </md-dialog>
    <div class="md-toolbar">
      <div class="md-toolbar-section-start">
        <span class="md-title">{{$t('requests')}}</span>
      </div>
      <md-field class="md-toolbar-section-end filter md-layout-item md-small-size-100" :class="{'md-invalid': errors.has('date')}">
        <md-input
          :placeholder="$t('date')"
          name="date"
          type="date"
          v-validate="'required'"
          v-model="dateFilter"/>
        <span class="md-error">{{ $t('requiredWarning') }}</span>
      </md-field>

      <md-field class="md-toolbar-section-end filter md-layout-item md-small-size-100"
                id="locals"
                name="locals"
                :class="{
                        'md-input-placeholder md-advanced-select': true,
                        'md-has-value': clientFilter,
                        'md-invalid': errors.has('client')
                      }">
        <label>{{$t('clients')}}</label>
        <advanced-select
          :options="clientsOptions"
          v-model="clientFilter"
          placeholder=""
          name="client">
        </advanced-select>
        <span class="md-error" v-if="errors.firstByRule('client','required')">{{ $t('required') }}</span>
      </md-field>

      <md-field class="md-toolbar-section-end filter md-layout-item md-small-size-100"
                id="locals"
                name="locals"
                :class="{
                        'md-input-placeholder md-advanced-select': true,
                        'md-has-value': localFilter,
                        'md-invalid': errors.has('local')
                      }">
        <label>{{$t('locations')}}</label>
        <advanced-select
          :options="locationsOptions"
          v-model="localFilter"
          placeholder=""
          name="local">
        </advanced-select>
        <span class="md-error" v-if="errors.firstByRule('local','required')">{{ $t('required') }}</span>
      </md-field>

    </div>
    
    <div class="batch-actions-toolbar" v-if="hasSelectableItems">
      <md-checkbox
        class="md-primary"
        :class="{'md-indeterminate': anySelected}"
        :title="$t('selectAll')"
        @change="handleSelectAllChange"
        v-model="allSelected">
      </md-checkbox>
      <div v-show="selectedRequests.length > 0" class="batch-buttons">
        <button
          class="md-button md-icon-button"
          @click="openBatchApproveDialog"
          :title="$t('approve')">
          <i class="md-icon md-icon-font md-primary">check</i>
        </button>
        <button
          class="md-button md-icon-button"
          @click="openBatchRejectDialog"
          :title="$t('reject')">
          <i class="md-icon md-icon-font md-error">clear</i>
        </button>
      </div>
    </div>
    
    <div class="md-card-content">
      <div>
        <div v-for="item in searched" :key="item.id">
          <collapse :title="getTime(item.date) + ' - ' + item.client.name + ' - ' + item.item">
            <template v-slot:prefix>
              <md-checkbox
                v-if="item.status === statusRequest.waiting && isFutureService(item)"
                class="md-primary item-checkbox"
                :value="item"
                v-model="selectedRequests"
                @change="handleItemCheckboxChange"
                @click.native.stop>
              </md-checkbox>
            </template>
            <div slot="header">
              <div v-if="item.status === statusRequest.waiting && isFutureService(item)">
                <button
                  class="md-button md-icon-button md-dense"
                  @click="openApproveDialog(item)"
                  :title="$t('approve')">
                  <i class="md-icon md-icon-font md-primary">check</i>
                </button>
                <button
                  class="md-button md-icon-button md-dense"
                  @click="openRejectDialog(item)"
                  :title="$t('reject')">
                  <i class="md-icon md-icon-font md-error">clear</i>
                </button>
              </div>
              <div v-else>
                <span v-if="item.status === statusRequest.waiting">{{$t('expired')}}</span>
                <span v-else>{{$t(statusRequest[item.status])}}</span>
              </div>
            </div>
            <div>
              <div class="event">
                <div class="md-body-2">
                  <i class="md-icon md-icon-font md-primary">control_point_duplicate</i>
                  <span>{{item.quantity}}</span>
                  <md-tooltip>{{$t('quantity')}}</md-tooltip>
                </div>
                <div class="md-body-2">
                  <i class="md-icon md-icon-font md-primary">attach_money</i>
                  <span>{{concatArrayWithComma(item.costCenters)}}</span>
                  <md-tooltip>{{$t('costCenter')}}</md-tooltip>
                </div>
                <div class="md-body-2">
                  <i class="md-icon md-icon-font md-primary">place</i>
                  <span>{{concatArrayWithCommaAndGetProp(item.locations)}}</span>
                  <md-tooltip>{{$t('locations')}}</md-tooltip>
                </div>
                <div class="md-body-2">
                  <i class="md-icon md-icon-font md-primary">meeting_room</i>
                  <span>{{concatArrayWithCommaAndGetProp(item.rooms)}}</span>
                  <md-tooltip>{{$t('rooms')}}</md-tooltip>
                </div>
                <div class="md-body-2">
                  <i class="md-icon md-icon-font md-primary">description</i>
                  <span>{{item.requestNotes ? item.requestNotes : '-'}}</span>
                  <md-tooltip>{{$t('description')}}</md-tooltip>
                </div>
              </div>
            </div>
          </collapse>
        </div>
        <md-empty-state
          v-if="!loading && searched && searched.length === 0"
          md-icon="event_note"
          :md-label="$t('requestNotFound')">
        </md-empty-state>
      </div>
    </div>
    <md-speed-dial class="md-bottom-right">
      <md-speed-dial-target class="md-primary" @click="openReportDialog">
        <md-icon>download</md-icon>
      </md-speed-dial-target>
      <md-tooltip md-direction="left"></md-tooltip>
      <md-tooltip md-direction="left">{{$t('downloadServiceDeskReport')}}</md-tooltip>
    </md-speed-dial>
    
  </div>
  
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/utils/utils.js'
import strings from '@/strings'

export default {
  name: 'SupplierItems',
  data: () => ({
    location: {
      active: true,
      allowBookingsAtTheSameInterval: false
    },
    search: null,
    searched: [],
    dialog: false,
    removeDialog: false,
    editing: false,
    locationsOptions: [],
    clientsOptions: [],
    statusRequest: strings.statusRequest,
    showDialog: false,
    dialogAction: () => {},
    dialogTitle: '',
    report: {
      dialog: false,
      filterDateIsInvalid: false,
      startDate: '',
      endDate: ''
    },
    selectedRequests: [],  // Array of selected items for batch operations
    allSelected: false     // Select-all checkbox state
  }),
  computed: {
    ...mapState('ServiceRequest', ['requests']),
    ...mapState('Client', ['clients']),
    ...mapState('Global', ['loading']),
    anySelected() {
      return this.selectedRequests.length > 0 && 
             this.selectedRequests.length < this.searched.length
    },
    hasSelectableItems() {
      return this.searched && this.searched.some(item => 
        item.status === this.statusRequest.waiting && this.isFutureService(item)
      )
    },
    dateFilter:{
      get () {
        return this.$store.getters['ServiceRequest/currentDate']
      },
      set (value) {
        this.$store.dispatch('ServiceRequest/setCurrentDate', value)
      }
    },
    localFilter: {
      get () {
        return this.$store.getters['ServiceRequest/locationQueryFilter']
      },
      set (value) {
        this.$store.dispatch('ServiceRequest/setLocationQueryFilter', value)
      }
    },
    clientFilter: {
      get () {
        return this.$store.getters['ServiceRequest/clientFilter']
      },
      set (value) {
        this.$store.dispatch('ServiceRequest/setClientFilter', value)
      }
    },
    daysDiffGreaterThanSevenDays () {
      let start = this.$moment(this.report.startDate, this.$moment.HTML5_FMT.DATE)
      let end = this.$moment(this.report.endDate, this.$moment.HTML5_FMT.DATE)
      let diff = end.diff(start, 'days')
      return diff > 7
    },
    reportStartDateGreaterThanEnd () {
      let start = this.$moment(this.report.startDate, this.$moment.HTML5_FMT.DATE)
      let end = this.$moment(this.report.endDate, this.$moment.HTML5_FMT.DATE)
      return start.isAfter(end)
    }
  },
  created () {
    this.getClients().then(() => {
      this.buildOptions()
      let now = this.$moment()
      this.dateFilter = now.format(this.$moment.HTML5_FMT.DATE)
    })
  },
  methods: {
    ...mapActions('ServiceRequest', [
    'getServicesRequest', 
    'clearFilters', 
    'approveRequest', 
    'rejectRequest', 
    'setSelectedRequest', 
    'getServiceDeskReport',
    'batchApproveRequests',
    'batchRejectRequests'
  ]),
    ...mapActions('Client', ['getClients']),
    buildOptions () {
      this.clients.forEach((client) => {
        this.clientsOptions.push({
          value: client.id,
          label: client.name
        })
      })
    },
    searchOnTable () {
      this.searched = this.requests
      if(this.clientFilter) {
        this.searched = this.searched.filter((request) => request.client.id === this.clientFilter)
      }
      if(this.localFilter){
        this.searched = this.searched.filter((request) => request.locations.some(location => location.id === this.localFilter))
      }
    },
    getTime (date) {
      return this.$moment(date).format(this.$t('LT'))
    },
    concatArrayWithCommaAndGetProp(array){
      return utils.concatArrayWithCommaAndGetProp(array, 'name')
    },
    concatArrayWithComma(array) {
      return utils.concatArrayWithComma(array)
    },
    openRejectDialog (item) {
      this.dialogTitle = this.$t('confirmReject')
      this.setSelectedRequest(item)
      this.showDialog = true
      this.dialogAction = this.rejectRequest
    },
    openApproveDialog (item) {
      this.dialogTitle = this.$t('confirmApprove')
      this.setSelectedRequest(item)
      this.showDialog = true
      this.dialogAction = this.approveRequest
    },
    isFutureService (item) {
      return this.$moment().diff(this.$moment(item.date)) <= 0
    },
    resetReportDialog () {
      this.report.dialog = false
      this.report.filterDateIsInvalid = false
      this.report.startDate = this.$moment().subtract(7, 'days').format(this.$moment.HTML5_FMT.DATE)
      this.report.endDate = this.$moment().format(this.$moment.HTML5_FMT.DATE)
    },
    openReportDialog () {
      this.report.dialog = true
      this.report.startDate = this.$moment().subtract(7, 'days').format(this.$moment.HTML5_FMT.DATE)
      this.report.endDate = this.$moment().format(this.$moment.HTML5_FMT.DATE)
    },
    closeReportDialog () {
      this.resetReportDialog()
    },
    async downloadReport () {
      let result = await this.$validator.validate('startDate') && await this.$validator.validate('endDate')
      if (!result) {
        return
      }

      if (this.daysDiffGreaterThanSevenDays || this.reportStartDateGreaterThanEnd) {
        return
      }

      let params = {
        startDate: this.report.startDate,
        endDate: this.report.endDate
      }
      this.closeReportDialog()
      await this.getServiceDeskReport(params)
    },
    handleSelectAllChange() {
      if (!this.allSelected) {
        this.selectedRequests = []
        return
      }
      this.selectedRequests = [...this.searched.filter(item => 
        item.status === this.statusRequest.waiting && this.isFutureService(item)
      )]
    },
    handleItemCheckboxChange() {
      if (this.selectedRequests.length > 0) {
        this.allSelected = true
      } else {
        this.allSelected = false
      }
    },
    openBatchApproveDialog() {
      this.dialogTitle = this.$t('batchApproveConfirm')
      this.showDialog = true
      this.dialogAction = this.performBatchApprove
    },
    openBatchRejectDialog() {
      this.dialogTitle = this.$t('batchRejectConfirm')
      this.showDialog = true
      this.dialogAction = this.performBatchReject
    },
    async performBatchApprove() {
      const results = await this.batchApproveRequests(this.selectedRequests)
      this.handleBatchResults(results)
    },
    async performBatchReject() {
      const results = await this.batchRejectRequests(this.selectedRequests)
      this.handleBatchResults(results)
    },
    handleBatchResults(results) {
      const failed = results.filter(r => r.status === 'rejected')
      const succeeded = results.filter(r => r.status === 'fulfilled')
      
      if (failed.length === 0) {
        // All succeeded - clear selection
        this.selectedRequests = []
        this.allSelected = false
        this.$showMessage({ message: 'batchOperationSuccess' })
      } else {
        // Some/all failed - keep only failed items selected
        this.selectedRequests = failed.map(f => f.item)
        this.allSelected = false
        this.$showMessage({ 
          message: 'batchOperationFailed', 
          messageValue: { count: failed.length, total: results.length } 
        })
      }
    },
    clearSelection() {
      this.selectedRequests = []
      this.allSelected = false
    },
  },
  watch: {
    clientFilter: function (val) {
      this.locationsOptions = []
      this.searchOnTable()
      this.clearSelection()
      if(val) {
        let client = this.clients.find(client => client.id === val)
        if(client.locations) {
          client.locations.forEach((location) => {
            this.locationsOptions.push({
              value: location.id,
              label: location.name
            })
          })
        }
      }
    },
    localFilter: function () {
      this.searchOnTable()
      this.clearSelection()
    },
    dateFilter: function () {
      this.getServicesRequest().then(()=>{
        this.searchOnTable()
      }).catch(() => {
        this.searchOnTable()
      })
      this.clearSelection()
    },
    requests: function () {
      this.searchOnTable()
      this.clearSelection()
    }
  },
  beforeDestroy () {
    this.clearFilters()
    this.clearSelection()
  }


}
</script>

<style lang="scss" scoped>

  .filter{
    margin-right: 20px;
  }

  .event {
    margin: 12px;
    padding: 5px 15px 0 15px;

    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }

  .md-subheader{
    padding: 0;
  }

  .subheader{
    display: flex;
    justify-content: space-between;
  }
  .md-body-2{
    margin-bottom: 5px;
    display: flex;
    span{
      padding-left: 8px;
    }
  }

  .md-dialog-content{
    min-width: 400px;
  }

  .batch-actions-toolbar {
    display: flex;
    align-items: center;
    gap: 0;
    padding: 12px 30px;
    border-bottom: 1px solid #e1e1e1;
  }

  .batch-buttons {
    display: flex;
    gap: 0;
  }

  .collapse-header-with-checkbox {
    display: flex;
    align-items: center;
    gap: 0;
  }

  .item-checkbox {
    margin: 0;
    margin-right: 8px;
  }

  ::v-deep .md-checkbox.md-indeterminate {
    .md-checkbox-container:after {
      border-color: #448aff !important;
      border-left: 0;
      transform: rotate(0deg);
    }
  }
</style>
